import { Languages } from "../../../enums/languages";

const checkReqStatusModalLang = {
    "modal-title": {
        [Languages.Hebrew]: { default: "בדיקת סטטוס בקשה" },
        [Languages.Arabic]: { default: "التحقق من حالة الطلب" },
        [Languages.English]: { default: "Check Request Status" }
    },
    "status-pandding": {
        [Languages.Hebrew]: { default: "הבקשה שלך נמצאת בטיפול" },
        [Languages.Arabic]: { default: "طلبك قيد المعالجة" },
        [Languages.English]: { default: "Your request is pending" }
    },
    "status-approved": {
        [Languages.Hebrew]: { default: "הבקשה שלך אושרה" },
        [Languages.Arabic]: { default: "تمت الموافقة على طلبك" },
        [Languages.English]: { default: "Your request is approved" }
    },
    "status-rejected": {
        [Languages.Hebrew]: { default: "הבקשה שלך נדחתה" },
        [Languages.Arabic]: { default: "تم رفض طلبك" },
        [Languages.English]: { default: "Your request is rejected" }
    }
};

export default checkReqStatusModalLang;